import { render, staticRenderFns } from "./HandleTaxTabGeneral.vue?vue&type=template&id=91820896"
import script from "./HandleTaxTabGeneral.vue?vue&type=script&lang=js"
export * from "./HandleTaxTabGeneral.vue?vue&type=script&lang=js"
import style0 from "./HandleTaxTabGeneral.vue?vue&type=style&index=0&id=91820896&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports